
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Landing from '@/pages/Landing';
import Index from '@/pages/Index';
import Search from '@/pages/Search';
import NotFound from '@/pages/NotFound';
import Children from '@/pages/Children';
import ChildDetails from '@/pages/ChildDetails';
import Quotes from '@/pages/Quotes';
import Milestones from '@/pages/Milestones';
import OnThisDay from '@/pages/OnThisDay';
import Settings from '@/pages/Settings';
import AccountSettings from '@/pages/AccountSettings';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import TermsOfService from '@/pages/TermsOfService';
import Support from '@/pages/Support';
import PostSignupFlow from '@/pages/PostSignupFlow';
import { ThemeProvider } from '@/context/ThemeContext';
import { AuthProvider } from '@/context/AuthContext';
import Login from '@/pages/Login';
import SignUp from '@/pages/SignUp';
import ScreenshotDemo from '@/pages/ScreenshotDemo';
import ContentTools from '@/pages/ContentTools';
import ProtectedRoute from '@/components/ProtectedRoute';
import { Toaster } from '@/components/ui/toaster';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/demo" element={<ScreenshotDemo />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/support" element={<Support />} />
            <Route path="/content-tools" element={<ContentTools />} />

            {/* Protected routes */}
            <Route path="/setup-check" element={
              <ProtectedRoute>
                <PostSignupFlow />
              </ProtectedRoute>
            } />
            <Route path="/app" element={
              <ProtectedRoute>
                <Index />
              </ProtectedRoute>
            } />
            <Route path="/search" element={
              <ProtectedRoute>
                <Search />
              </ProtectedRoute>
            } />
            <Route path="/children" element={
              <ProtectedRoute>
                <Children />
              </ProtectedRoute>
            } />
            <Route path="/children/:id" element={
              <ProtectedRoute>
                <ChildDetails />
              </ProtectedRoute>
            } />
            <Route path="/quotes" element={
              <ProtectedRoute>
                <Quotes />
              </ProtectedRoute>
            } />
            <Route path="/milestones" element={
              <ProtectedRoute>
                <Milestones />
              </ProtectedRoute>
            } />
            <Route path="/on-this-day" element={
              <ProtectedRoute>
                <OnThisDay />
              </ProtectedRoute>
            } />
            <Route path="/settings" element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            } />
            <Route path="/account-settings" element={
              <ProtectedRoute>
                <AccountSettings />
              </ProtectedRoute>
            } />
            {/* Redirect /auth to /login for backward compatibility */}
            <Route path="/auth" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Toaster />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
